import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";
import useJStyles from "$hooks/useJStyles";
import { Modal, Table, Text } from "$components";
import { CustomTableProps } from "$components/Table/Table";
import { EDBIntegratedOrders } from "$types/EDBIntegratedOrders";
import useEDBIntegratedOrdersTable from "../../hooks/useIntegratedOrdersTable";
import useRemainingIntegratedOrders from "$containers/EDB/OrdersAndReceptions/useRemainingIntegratedOrders";

type Props = {
  integratedOrders: EDBIntegratedOrders;
  onDeleteIntegratedProduct: (integratedOrders: EDBIntegratedOrders) => void;
  setIntegratedOrders: (integratedOrders: EDBIntegratedOrders) => void;
  updateProducts: () => void;
  edbProducts?: any[];
  opList?: any[];
  isEdbDisabled?: boolean;
} & Partial<CustomTableProps>;

function IntegratedOrdersRecapTable({
  integratedOrders,
  onDeleteIntegratedProduct,
  setIntegratedOrders,
  updateProducts,
  edbProducts,
  opList,
  isEdbDisabled,
  ...customTableProps
}: Props) {
  const { jclasses } = useJStyles();

  const { remainingIntegratedOrders } = useRemainingIntegratedOrders(
    integratedOrders,
    edbProducts || []
  );

  const {
    openConfirmDelete,
    openConfirmDeleteSuborder,
    allProductsBySuborder,
    suborderToDelete,
    handleCancelDialog,
    handleCancelSuborderDialog,
    getRecapThead: getThead,
    handleRecapValidateDialog,
    handleRecapValidateSuborderDialog,
    renderRecapProducts: renderProducts,
  } = useEDBIntegratedOrdersTable({
    integratedOrders,
    remainingIntegratedOrders,
    updateProducts,
    setIntegratedOrders,
    onDeleteIntegratedProduct,
    edbProducts,
    opList,
    isEdbDisabled,
  });

  return (
    <>
      {allProductsBySuborder?.map((productsBySuborder) => (
        <Table
          key={productsBySuborder.suborderReference}
          bodyData={renderProducts(productsBySuborder)}
          rowsPerPage={productsBySuborder.products.length}
          thead={getThead(productsBySuborder)}
          usePaper={false}
          noPointer
          noHover
          {...customTableProps}
        />
      ))}
      <Modal
        title="Confirmation de suppression"
        open={openConfirmDelete}
        onCancel={handleCancelDialog}
        onValidate={handleRecapValidateDialog}
      >
        <div className={jclasses.jDialogContent}>
          <Text>
            Souhaitez vous supprimer ce produit de l&apos;expression de besoin ?
          </Text>
        </div>
      </Modal>
      <Modal
        title="Confirmation de suppression"
        open={openConfirmDeleteSuborder}
        onCancel={handleCancelSuborderDialog}
        onValidate={handleRecapValidateSuborderDialog}
      >
        <div className={jclasses.jDialogContent}>
          <Text>
            Souhaitez vous supprimer{" "}
            {suborderToDelete?.hasOnlyOneSuborder
              ? `toute la commande n°${suborderToDelete?.orderReference}`
              : `toute la sous-commande n°${suborderToDelete?.suborderReference}`}{" "}
            de l&apos;expression de besoin ?
          </Text>
          <Text style={{ marginTop: 8, fontStyle: "italic" }}>
            ({suborderToDelete?.products?.length || 0} produit
            {(suborderToDelete?.products?.length || 0) > 1 ? "s" : ""} seront
            supprim&eacute;s)
          </Text>
        </div>
      </Modal>
    </>
  );
}

export default IntegratedOrdersRecapTable;

export const useStyles = createUseStyles(() => ({
  blueIcon: {
    color: `${theme.color.blueLight} !important`,
  },
  deleteButton: {
    color: "rgba(0, 0, 0) !important",
    border: "none !important",
    "&:hover": {
      color: "rgba(0, 0, 0) !important",
      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
    },
    "& svg": {
      color: "inherit !important",
    },
  },
}));
